import React from "react";
import BarraDePasos from "./BarraDePasos";
import FichaReserva from "../Hoteles/ProcesoCompraCdr/FichaReservaCdr";
import { Link, withRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

const LayoutCompra = (props) => {
  const { children, paso } = props;

  const handleLink = () => {
    if (paso === '2') {
      props.history.go(-2);
    } else {
      props.history.goBack();
    }
  }

  return (
    <section className="checkout-steps">
      <div className="container">
        <div className="row">
          <div className="content col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12">
            <BarraDePasos paso={paso} isCDR />
            {children}
            <div className="listado">
              <Link to="#" onClick={handleLink}>
                Volver al listado
              </Link>
            </div>
          </div>

          <FichaReserva />
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default withRouter(LayoutCompra);



// WEBPACK FOOTER //
// ./src/components/Global/LayoutCompra.js